import API from '../../apis';
import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';

export const loginOrRegister = (mobileNumber) => {
  const request = () => {
    return (dispatch) => {
      dispatch(loading());
      return API.login
        .loginOrRegister(mobileNumber)
        .then((res) => dispatch(success(res)))
        .catch((err) => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.LOGIN_OR_REGISTER_FAILED,
              reject: actionTypes.LOGIN_OR_REGISTER_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.LOGIN_OR_REGISTER_LOADING);
  const success = (res) => action(actionTypes.LOGIN_OR_REGISTER_SUCCESS, res);

  return request();
};

export const registerNewUser = (data) => {
  const request = () => {
    return (dispatch) => {
      dispatch(loading());
      return API.login
        .Register(data)
        .then((res) => dispatch(success(res)))
        .catch((err) => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.REGISTER_NEW_USER_FAILED,
              reject: actionTypes.REGISTER_NEW_USER_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.REGISTER_NEW_USER_LOADING);
  const success = (res) => action(actionTypes.REGISTER_NEW_USER_SUCCESS, res);

  return request();
};

export const verificationCodeBySMS = (mobileNumber) => {
  const request = () => {
    return (dispatch) => {
      dispatch(loading());
      return API.login
        .verificationCodeBySMS(mobileNumber)
        .then((res) => dispatch(success(res)))
        .catch((err) => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.SEND_VERIFICATION_CODE_FAILED,
              reject: actionTypes.SEND_VERIFICATION_CODE_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.SEND_VERIFICATION_CODE_LOADING);
  const success = (res) =>
    action(actionTypes.SEND_VERIFICATION_CODE_SUCCESS, res);

  return request();
};

export const loginByVerifyPhoneNumber = (data) => {
  const request = () => {
    return (dispatch) => {
      dispatch(loading());
      return API.login
        .loginByVerifyPhoneNumber(data)
        .then((res) => dispatch(success(res)))
        .catch((err) => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.LOGIN_BY_VERIFICATION_CODE_FAILED,
              reject: actionTypes.LOGIN_BY_VERIFICATION_CODE_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.LOGIN_BY_VERIFICATION_CODE_LOADING);
  const success = (res) =>
    action(actionTypes.LOGIN_BY_VERIFICATION_CODE_SUCCESS, res);

  return request();
};

export const loginByPassword = (data) => {
  const request = () => {
    return (dispatch) => {
      dispatch(loading());
      return API.login
        .loginByPassword(data)
        .then((res) => dispatch(success(res)))
        .catch((err) => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.LOGIN_BY_PASSWORD_FAILED,
              reject: actionTypes.LOGIN_BY_PASSWORD_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.LOGIN_BY_PASSWORD_LOADING);
  const success = (res) => action(actionTypes.LOGIN_BY_PASSWORD_SUCCESS, res);

  return request();
};

export const setPassword = (data) => {
  const request = () => {
    return (dispatch) => {
      dispatch(loading());
      return API.login
        .setPassword(data)
        .then((res) => dispatch(success(res)))
        .catch((err) => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.SET_PASSWORD_FAILED,
              reject: actionTypes.SET_PASSWORD_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.SET_PASSWORD_LOADING);
  const success = (res) => action(actionTypes.SET_PASSWORD_SUCCESS, res);

  return request();
};

export const changePassword = (data) => {
  const request = () => {
    return (dispatch) => {
      dispatch(loading());
      return API.login
        .changePassword(data)
        .then((res) => dispatch(success(res)))
        .catch((err) => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CHANGE_PASSWORD_FAILED,
              reject: actionTypes.CHANGE_PASSWORD_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CHANGE_PASSWORD_LOADING);
  const success = (res) => action(actionTypes.CHANGE_PASSWORD_SUCCESS, res);

  return request();
};

export const forgetPassword = (data) => {
  const request = () => {
    return (dispatch) => {
      dispatch(loading());
      return API.login
        .forgetPassword(data)
        .then((res) => dispatch(success(res)))
        .catch((err) => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FORGET_PASSWORD_FAILED,
              reject: actionTypes.FORGET_PASSWORD_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FORGET_PASSWORD_LOADING);
  const success = (res) => action(actionTypes.FORGET_PASSWORD_SUCCESS, res);

  return request();
};
